import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from './themeColors';

export default makeStyles((theme: Theme) => ({
  statusStyle: {
    color: themeColors.success,
  },
  inactiveRow: {
    color: themeColors.inactive,
  },
  cellSize: {
    maxWidth: '26ch',
    wordWrap: 'break-word',
  },
  imageCell: {
    padding: 0,
  },
}));
